// extracted by mini-css-extract-plugin
export default {"balanceInput":"InitialBalancesStep_balanceInput__gWZYi","label":"InitialBalancesStep_label__7gblK","content":"InitialBalancesStep_content__R0w4M"};